import {
  Component,
  ElementRef,
  HostListener,
  ViewChild,
  ViewEncapsulation,
  input,
  output,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { WcgLinkComponent } from '@wcg/frontend-framework';

@Component({
  selector: 'wcg-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.css'],
  imports: [
    MatProgressSpinnerModule,
    MatButtonModule,
    MatIconModule,
    WcgLinkComponent,
  ],
  encapsulation: ViewEncapsulation.None,
})
export class WcgUploadFileComponent {
  readonly multiSelect = input(false);
  readonly fileUpload = output<File[]>();

  @ViewChild('fileInput') fileInput!: ElementRef;

  async fileChanged(e: Event) {
    const input = e.target as HTMLInputElement;

    if (!input.files) {
      return;
    }

    this.fileUpload.emit(Array.from(input.files));
    this.fileInput.nativeElement.value = '';
  }

  deleteFile() {
    this.fileInput.nativeElement.value = '';
  }

  @HostListener('dragover', ['$event']) onDragOver(event: any) {
    event.preventDefault();
  }
  @HostListener('dragenter', ['$event']) onDragEnter(event: any) {
    event.preventDefault();
  }
  @HostListener('dragend', ['$event']) onDragEnd(event: any) {
    event.preventDefault();
  }
  @HostListener('dragleave', ['$event']) onDragLeave(event: any) {
    event.preventDefault();
  }
  @HostListener('drop', ['$event']) onDrop(e: any) {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer.files) {
      const files: FileList = e.dataTransfer.files;

      if (files) {
        this.fileUpload.emit(Array.from(files));
      }
    }
  }
}
